import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactTransliterate, TriggerKeys } from "react-transliterate";
import { shirtOptionOne, shirtOptionTwo } from "../data/options";
import { shirtType } from "../data/types";
import { selectToggle } from "../redux/slices/NavigationSlice";

import ShirtImageDropdown from "./ImageDropDown/ShirtImageDropdown";
import ShirtMeasurement from "./measurement/ShirtMeasurement";

const shirtOptions = [...shirtOptionOne, ...shirtOptionTwo];

const Shirt = ({ formik, options, handleShirtOptionChange }) => {
  const { t } = useTranslation();
  const lang = useSelector(selectToggle);

  return (
    <section className="dp-panel">
      <div className="dp-panel-head">
        <span className="dp-panel-dot" />
        <h4>{t("common.shirt")}</h4>
      </div>

      <div className="dp-panel-body">
        {/* type */}
        <div className="dp-panel-row">
          <div className="dp-fld">
            <label>{t("common.type")}</label>
            <select
              className="form-select"
              id="customer.shirt.shirtType"
              onChange={formik.handleChange}
              value={formik.values.customer.shirt.shirtType}
            >
              {shirtType.map((type) => (
                <option key={type.key} value={type.key}>
                  {t(type.name)}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* measurements */}
        <div className="dp-sub-label">{t("common.measurement")}</div>
        <div className="dp-measure">
          <ShirtMeasurement type="shirt" formik={formik} />
        </div>

        {/* style + options, side by side */}
        <div className="dp-style-options">
          <div className="dp-fld">
            <div className="dp-sub-label">{t("common.style")}</div>
            <ShirtImageDropdown formik={formik} type={"customer.shirt"} />
          </div>

          <div className="dp-fld dp-opts-fld">
            <div className="dp-sub-label">{t("common.options")}</div>
            <div className="dp-opts">
              {shirtOptions.map(({ key, name }) => (
              <button
                type="button"
                key={key}
                className={options.includes(key) ? "dp-opt on" : "dp-opt"}
                onClick={() => handleShirtOptionChange(key)}
                aria-pressed={options.includes(key)}
              >
                <span className="dp-opt-tick" aria-hidden="true">
                  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="m3 8 3.5 3.5L13 4.5" />
                  </svg>
                </span>
                {t(name)}
              </button>
            ))}
            </div>
          </div>
        </div>

        {/* details */}
        <div className="dp-fld dp-details">
          <label>{t("common.details")}</label>
          <ReactTransliterate
            value={formik.values.customer.shirt.shirtDetails}
            renderComponent={(props) => <textarea rows={2} {...props} />}
            onFocus={(e) => e.target.select()}
            onChangeText={(text) => {
              formik.setFieldValue("customer.shirt.shirtDetails", text);
            }}
            className="form-control"
            lang={lang}
            enabled={lang !== "en"}
            triggerKeys={[
              TriggerKeys.KEY_RETURN,
              TriggerKeys.KEY_ENTER,
              TriggerKeys.KEY_SPACE,
              TriggerKeys.KEY_TAB,
            ]}
          />
        </div>

        {/* count — last field in the panel */}
        <div className="dp-fld dp-count">
          <label>{t("common.count")}</label>
          <input
            type="number"
            className="form-control"
            onFocus={(e) => e.target.select()}
            id="customer.shirt.shirtCount"
            onChange={formik.handleChange}
            value={formik.values.customer.shirt.shirtCount}
          />
        </div>
      </div>
    </section>
  );
};

export default Shirt;
